//////////////////////////////////////////////
//! WebCamView 
//////////////////////////////////////////////

SliderView = function( url , height , dispatcher , eventName ) {

//--------------------------------------------
//! Static Vars
//--------------------------------------------

	this.WHITE_COLOR = 0xffffff;

//--------------------------------------------
//! Vars
//--------------------------------------------
	this.eventName = eventName;
	this.url = url;
	this.height = height;
	this.container = new PIXI.Container();
	this.dispatcher = dispatcher;

//--------------------------------------------/

	this.loadAsset();

};

SliderView.prototype = {

	constructor : SliderView,

	/*---------------------------------------------------
		INITIALIZER
	--------------------------------------------------*/

	init : function() {
		console.log("loaded")
		this.initView();
		this.bindEvents();
		this.toggleView( false );

	},

	/*---------------------------------------------------
		FUNCTIONS 
	--------------------------------------------------*/

	loadAsset : function(){
	
		this.pixiLoader = new PIXI.loaders.Loader();
		this.pixiLoader.on( "complete" ,  this.onAssetReady.bindX( this ) );
		this.pixiLoader.add( "img" , this.url );
		this.pixiLoader.load();
	},

	initView : function(){

		this.initBKGround();
		this.initSliderBox();

	},

	bindEvents : function() {
		// events for drag start

		this.btn.on( 'mousedown' , this.onDragStart.bindX( this ) );
		this.btn.on( 'touchstart' , this.onDragStart.bindX( this ) );

		// events for drag end

		this.btn.on( 'mouseup', this.onDragEnd.bindX( this ) );
		this.btn.on( 'mouseupoutside', this.onDragEnd.bindX( this ) );
		this.btn.on( 'touchend', this.onDragEnd.bindX( this ) );
		this.btn.on( 'touchendoutside', this.onDragEnd.bindX( this ) );

		// events for drag move

		this.btn.on( 'mousemove', this.onDragMove.bindX( this ) );
		this.btn.on( 'touchmove', this.onDragMove.bindX( this ) );

	},

	initBKGround : function(){

		this.line = new PIXI.Graphics();
		//movie release date Box
		this.line = new PIXI.Graphics();
		this.line.beginFill( this.WHITE_COLOR );
		this.line.drawRect( 0, 0, 5, this.height );
		this.line.endFill();

		this.container.addChild(this.line);

	},

	initSliderBox : function(){
		
		this.btn = new PIXI.Sprite( this.pixiLoader.resources.img.texture );
		this.btn.resolution = 2;
		this.btn.interactive = true;
		this.btn.buttonMode = true;
		this.btn.position.y = this.height - this.btn.height ;
		this.container.addChild( this.btn );

		this.line.position.set( (this.btn.width / 2)-2.5 , 0 );

	},

	toggleView : function( visible ){
		if(visible) this.show()
		else this.hide();
	},
	
	reset : function(){
		this.btn.position.y = this.height - this.btn.height ;
	},

	checkDragLimits : function( pos ){
		var maxY = ( this.height - this.btn.height )
	
		if( ( pos <= maxY ) 
			&& ( pos >= 0 ) ){
			return true;
		}else{
			//this.correctDragPositionY();
			return false;
		}
	},

	validateValue : function() {
 
		if(this.btn.y < 0) this.btn.position.y  = 0;
		
 
		if(this.btn.position.y > (this.height - this.btn.height )){
			this.btn.position.y  = this.height - this.btn.height;
		
		}

 	},

 	calculateDragValues : function() {

 		var percent = this.btn.y / ( this.height - this.btn.height );
 	
 		var value = (( ( this.max - this.min ) * ( percent - 0 ) ) / (1 - 0)) + this.min;
 	
 		this.dispatcher.dispatch(this.eventName , value );

 	},
 	
 	hide : function(){
 		TweenMax.fromTo(this.container,0.2,{alpha:1},{alpha:0,onComplete:function(){
 			this.container.visible = false;
 		}.bindX(this)});
 	},
 	show : function(){
 		this.container.visible = true;
 		TweenMax.fromTo(this.container,0.5,{alpha:0},{delay:0.3,alpha:1});
 	},
	/*---------------------------------------------------
		EVENT HANDLERS 
	--------------------------------------------------*/
	
	onAssetReady : function(){

		this.init();

	},

	/****************************************************
		DRAGING HANDLERS 
	//***************************************************/

	onDragStart : function ( e ) {
		this.data = e.data;
		this.downPos = this.btn.position.y;
		this.downY = this.data.getLocalPosition( this.container ).y;

		//this.startY = this.btn.position.y;
		//var newPositionY = this.data.getLocalPosition( this.container ).y;
		//
//
		
		//var newPosition = this.data.getLocalPosition( this.container );
		//this.distanceY = newPosition.y ;
		


		this.dragging = true;

	},

	onDragEnd : function( e ) {

		this.dragging = false;
		this.data = null;

	},

	onDragMove : function() {
		
		if ( this.dragging ) {
			this.btn.y = this.downPos + (this.data.getLocalPosition(this.container).y - this.downY );
 
			this.validateValue();
 			this.calculateDragValues();
			//this.dispatchEvent("change");

		}
	}

};
